import { ProductItem } from './ProductItem';

interface ProductListProps {
  products: Array<{
    id: string;
    name: string;
    code: string;
    image: string;
    qty: number;
  }>;
  scannedQuantities: Record<string, number>;
  flashingProducts: Set<string>;
  selectedBatchIds: Record<string, number | null>;
  onBatchChange: (productId: string, batchId: number | null) => void;
}

export const ProductList = ({
  products,
  scannedQuantities,
  flashingProducts,
  selectedBatchIds,
  onBatchChange,
}: ProductListProps) => {
  return (
    <div className="space-y-6">
      {products.map((product) => (
        <ProductItem
          key={product.id}
          product={product}
          scannedQuantity={scannedQuantities[product.code] || 0}
          isFlashing={flashingProducts.has(product.code)}
          batchId={selectedBatchIds[product.id] ?? null}
          onBatchChange={onBatchChange}
        />
      ))}
    </div>
  );
};
